/**
 * @file PsyAssessService urls
 * encryption 字段为是否需要加密
 */

export default {
    sendCode: {
        url: "PsyAssessService/SendCode",
        method: 'post',
        encryption: 'md5'
    },
    valCode: {
        url: "PsyAssessService/ValCode",
        method: 'post',
        encryption: 'md5'
    },
    getQuestion: {
        url: 'PsyAssessService/GetQuestion',
        method: 'post',
        encryption: 'md5'
    },
    getScore: {
        url: 'PsyAssessService/GetScore',
        method: 'post',
        encryption: 'md5'
    }
} as Record<string, NetTypes.Api>;
